import { Component, Input, OnChanges } from '@angular/core';
import { TermsLinks } from 'src/app/components/auth/models/interface/termsLinks.interface';
import { sharedAuthConstants } from 'src/app/components/shared/sharedConstants/auth.constants';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { AuthLoginFlag } from '../../models/auth-login.flags.enum';

@Component({
  selector: 'app-auth-login-terms-modal',
  templateUrl: './auth-login-terms-modal.component.html',
  styleUrls: ['./auth-login-terms-modal.component.sass']
})
export class AuthLoginTermsModalComponent implements OnChanges {
  @Input() flagList: Flags<AuthLoginFlag>;
  @Input() termsLinks: TermsLinks;
  @Input() countryId: number;
  flagEnum = AuthLoginFlag;
  contactEmail: string;

  constructor() {
    /** */
  }

  ngOnChanges(): void {
    this.contactEmail = sharedAuthConstants.contactLink[this.countryId];
  }
}
